export default "__VITE_ASSET__DAB7JNLG__"